import {Authority} from '@/shared/security/authority';

const Kalender = () => import('@/kalender/calender.vue');

export default [
  {
    path: '/kalender',
    name: 'Kalender',
    component: Kalender,
    meta: { authorities: [Authority.USER] },
  }
];
